import { t } from '../../../../utils/i18n';
import { getDisplayItems } from '../utils/getTransactionInfo';
import { WidgetProps } from '../../../../types/WidgetProps';
import { BiLogger } from '../../../Hoc/BiLogger/BiLoggerProvider';
import { GooglePayButtonConfig } from '../types';

type CreateOnShippingMethodSelectedParams = {
  topProps: WidgetProps;
  transactionInfo: google.payments.api.TransactionInfo;
  biLogger: BiLogger;
};

type OnShippingMethodSelectedParams = Parameters<
  GooglePayButtonConfig['onPaymentDataChanged']
>[0]['shippingOptionData'];

export const createOnShippingMethodSelected =
  ({ topProps, transactionInfo }: CreateOnShippingMethodSelectedParams) =>
  async (
    params: OnShippingMethodSelectedParams,
  ): Promise<ReturnType<GooglePayButtonConfig['onPaymentDataChanged']>> => {
    // TODO: DimaM check did vertical also update 'topProps' with new 'shippingMethods' on 'onShippingContactChange' if not -> create inner state
    const selectedMethod = topProps?.shippingMethods.find((method) => method.identifier === params.id);
    try {
      const updates = await topProps.onShippingMethodSelected(selectedMethod);

      return {
        newTransactionInfo: {
          ...transactionInfo,
          totalPrice: updates.paymentAmount,
          ...(updates.paymentBreakdown && { displayItems: getDisplayItems(updates.paymentBreakdown) }),
        },
      };
    } catch (error) {
      return {
        error: {
          reason: 'OTHER_ERROR',
          intent: 'SHIPPING_OPTION',
          message: t('pm.shipping.optionChange.unknownError'),
        },
      };
    }
  };
